import { initReactI18next } from 'react-i18next';
import {
	readLocalePreference,
	resolveLocale,
	SUPPORTED_LOCALES,
} from '@/store/theme/localePreference';
import { themeConfig } from '@/configs/theme.config';
import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

const detectedLng = resolveLocale(readLocalePreference(), themeConfig.locale);

i18n
	.use(resourcesToBackend((language) => import(`./lang/${language}.json`)))
	.use(initReactI18next)
	.init({
		lng: detectedLng,
		fallbackLng: themeConfig.locale,
		supportedLngs: SUPPORTED_LOCALES,
		load: 'currentOnly',
		lowerCaseLng: true,
		keySeparator: false,
		nsSeparator: false,
		interpolation: {
			escapeValue: false,
		},
	});

export const dateLocales = {
	'en': () => import('dayjs/locale/en'),
	'pt-br': () => import('dayjs/locale/pt-br'),
	'es': () => import('dayjs/locale/es'),
	'it': () => import('dayjs/locale/it'),
	'fr': () => import('dayjs/locale/fr'),
	'de': () => import('dayjs/locale/de'),
	'pl': () => import('dayjs/locale/pl'),
};

export default i18n;
